
































import { mixins } from 'vue-class-component'
import { Component, Prop, Emit } from 'vue-property-decorator'
import AppTextarea from '@/components/AppTextarea.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppSelector from '@/components/AppSelector.vue'
import SearchPolicy from '@/mixins/search-queries/search-policy'
import { ICasePolicyInput } from '@/modules/Case/interfaces/case-form'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { policyStatus, policyStatusClass } from '@/modules/Policy/helpers/policy'
import { dateToDisplay } from '@/utils/dateTime'

@Component({
  components: {
    AppTextSearch,
    AppTextField,
    AppSelector,
    AppTextarea
  }
})
export default class CaseFormPolicy extends mixins(SearchPolicy) {
  @Prop({ type: Object as () => ICasePolicyInput }) value!: ICasePolicyInput
  @Prop({ type: Boolean }) ifPolicy!: boolean
  @Prop({ type: Boolean }) disabled!: boolean

  policyStatusClass = policyStatusClass
  policyStatus = policyStatus
  dateToDisplay = dateToDisplay

  selectHandler (idx: number) {
    (this.$refs.search as AppTextSearch).selectHandler(idx + 1)
    const policy: any = this.candidatesPolicyOptions[idx]
    this.onPolicySelected(policy)
  }

  @Emit('selected')
  onPolicySelected (policy: Policy) {
    return policy
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
